import { render, staticRenderFns } from "./StarBoard.vue?vue&type=template&id=e45e77d2"
import script from "./StarBoard.vue?vue&type=script&lang=js"
export * from "./StarBoard.vue?vue&type=script&lang=js"
import style0 from "./StarBoard.vue?vue&type=style&index=0&id=e45e77d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports